var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#DC143C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1454 31.854C18.1918 31.9005 18.247 31.9374 18.3077 31.9625C18.3684 31.9877 18.4335 32.0006 18.4992 32.0006C18.5649 32.0006 18.6299 31.9877 18.6906 31.9625C18.7513 31.9374 18.8065 31.9005 18.8529 31.854L24.9982 25.7087L31.1459 31.854C31.2398 31.9478 31.367 32.0005 31.4997 32.0005C31.6324 32.0005 31.7596 31.9478 31.8535 31.854C31.9473 31.7602 32 31.6329 32 31.5002C32 31.3675 31.9473 31.2403 31.8535 31.1465L25.7057 25.0012L31.851 18.8535C31.9448 18.7596 31.9975 18.6324 31.9975 18.4997C31.9975 18.367 31.9448 18.2397 31.851 18.1459C31.7571 18.0521 31.6299 17.9994 31.4972 17.9994C31.3645 17.9994 31.2373 18.0521 31.1434 18.1459L24.9982 24.2937L18.8504 18.1484C18.7548 18.0665 18.6317 18.0237 18.5059 18.0286C18.38 18.0334 18.2607 18.0856 18.1716 18.1746C18.0826 18.2637 18.0304 18.3831 18.0255 18.5089C18.0207 18.6348 18.0635 18.7578 18.1454 18.8535L24.2907 25.0012L18.1454 31.149C18.0523 31.2426 18 31.3694 18 31.5015C18 31.6336 18.0523 31.7603 18.1454 31.854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.288cd276980d07de2cde0fb7f63b1068.svg";
export { ForwardRef as ReactComponent };